<div class="dropdown d-inline-block" dropdown>
  <div dropdownToggle class="dropdown-toggle d-inline-block">
    <ng-content select="ls-dropdown-toggle"></ng-content>
  </div>
  <div *dropdownMenu class="dropdown-menu raised-block p-0 border-0 mt-1" [ngClass]="['dropdown-menu-' + placement]" role="menu">
    <ng-content select="ls-dropdown-menu"></ng-content>
  </div>
</div>
